"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linker = void 0;

var Utils_1 = require("../../../Utils");

var ParticlesInteractorBase_1 = require("../../../Core/ParticlesInteractorBase");

function getLinkDistance(pos1, pos2, optDistance, canvasSize, warp) {
  var distance = (0, Utils_1.getDistance)(pos1, pos2);

  if (!warp || distance <= optDistance) {
    return distance;
  }

  var pos2NE = {
    x: pos2.x - canvasSize.width,
    y: pos2.y
  };
  distance = (0, Utils_1.getDistance)(pos1, pos2NE);

  if (distance <= optDistance) {
    return distance;
  }

  var pos2SE = {
    x: pos2.x - canvasSize.width,
    y: pos2.y - canvasSize.height
  };
  distance = (0, Utils_1.getDistance)(pos1, pos2SE);

  if (distance <= optDistance) {
    return distance;
  }

  var pos2SW = {
    x: pos2.x,
    y: pos2.y - canvasSize.height
  };
  distance = (0, Utils_1.getDistance)(pos1, pos2SW);
  return distance;
}

var Linker =
/*#__PURE__*/
function (_ParticlesInteractorB) {
  _inherits(Linker, _ParticlesInteractorB);

  function Linker(container) {
    _classCallCheck(this, Linker);

    return _possibleConstructorReturn(this, _getPrototypeOf(Linker).call(this, container));
  }

  _createClass(Linker, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.links.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var _a;

      p1.links = [];
      var pos1 = p1.getPosition();
      var container = this.container;
      var canvasSize = container.canvas.size;

      if (pos1.x < 0 || pos1.y < 0 || pos1.x > canvasSize.width || pos1.y > canvasSize.height) {
        return;
      }

      var linkOpt1 = p1.options.links;
      var optOpacity = linkOpt1.opacity;
      var optDistance = (_a = p1.retina.linksDistance) !== null && _a !== void 0 ? _a : container.retina.linksDistance;
      var warp = linkOpt1.warp;
      var range = warp ? new Utils_1.CircleWarp(pos1.x, pos1.y, optDistance, canvasSize) : new Utils_1.Circle(pos1.x, pos1.y, optDistance);
      var query = container.particles.quadTree.query(range);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;
          var linkOpt2 = p2.options.links;

          if (p1 === p2 || !linkOpt2.enable || linkOpt1.id !== linkOpt2.id || p2.spawning || p2.destroyed || p1.links.map(function (t) {
            return t.destination;
          }).indexOf(p2) !== -1 || p2.links.map(function (t) {
            return t.destination;
          }).indexOf(p1) !== -1) {
            continue;
          }

          var pos2 = p2.getPosition();

          if (pos2.x < 0 || pos2.y < 0 || pos2.x > canvasSize.width || pos2.y > canvasSize.height) {
            continue;
          }

          var distance = getLinkDistance(pos1, pos2, optDistance, canvasSize, warp && linkOpt2.warp);

          if (distance > optDistance) {
            return;
          }

          var opacityLine = (1 - distance / optDistance) * optOpacity;
          this.setColor(p1);
          p1.links.push({
            destination: p2,
            opacity: opacityLine
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "setColor",
    value: function setColor(p1) {
      var container = this.container;
      var linksOptions = p1.options.links;
      var linkColor = linksOptions.id === undefined ? container.particles.linksColor : container.particles.linksColors.get(linksOptions.id);

      if (!linkColor) {
        var optColor = linksOptions.color;
        linkColor = (0, Utils_1.getLinkRandomColor)(optColor, linksOptions.blink, linksOptions.consent);

        if (linksOptions.id === undefined) {
          container.particles.linksColor = linkColor;
        } else {
          container.particles.linksColors.set(linksOptions.id, linkColor);
        }
      }
    }
  }]);

  return Linker;
}(ParticlesInteractorBase_1.ParticlesInteractorBase);

exports.Linker = Linker;